import React, {useState} from 'react';
import MediaLibraryManager from './MediaLibraryManager';

function describeFile(file) {
    return file ? `${file.title || file.filename} (id ${file.id})` : 'none';
}

export default function MediaLibraryDemo() {
    const [pickerVariant, setPickerVariant] = useState(null);
    const [selected, setSelected] = useState(null);
    const [events, setEvents] = useState([]);

    const log = message => {
        const timestamped = `${new Date().toLocaleTimeString()} — ${message}`;
        setEvents(current => [timestamped, ...current].slice(0, 5));
    };

    return (
        <section className="media-system-demo">
            <h2>Media Library v2 (React Demo)</h2>
            <div className="content">
                <p>
                    The full-page manager below is the future{' '}
                    <code>/account/media?uiVersion=2</code> surface. This staging mount does not
                    replace the legacy route yet.
                </p>
                <MediaLibraryManager
                    variant="page"
                    onUpload={file => log(`onUpload: ${describeFile(file)}`)}
                    onDelete={file => log(`onDelete: ${describeFile(file)}`)}
                />

                <div className="media-system-demo-picker">
                    <h3>Embedded picker contracts</h3>
                    <p>
                        Selected: <strong>{describeFile(selected)}</strong>
                    </p>
                    <button
                        type="button"
                        className="button"
                        onClick={() => setPickerVariant('modal')}
                    >
                        Open modal picker
                    </button>{' '}
                    <button
                        type="button"
                        className="button secondary"
                        onClick={() => setPickerVariant('popover')}
                    >
                        Open popup picker
                    </button>

                    {pickerVariant === 'popover' && (
                        <MediaLibraryManager
                            variant="popover"
                            title="Add media to post"
                            selectable
                            initialValue={selected?.id}
                            onSelect={file => {
                                setSelected(file);
                                log(`onSelect: ${describeFile(file)}`);
                                setPickerVariant(null);
                            }}
                            onCancel={() => {
                                log('onCancel');
                                setPickerVariant(null);
                            }}
                            onUpload={file => log(`onUpload: ${describeFile(file)}`)}
                        />
                    )}
                </div>

                {events.length > 0 && (
                    <div className="media-system-demo-events" aria-live="polite">
                        <h4>Callback events</h4>
                        <ul>
                            {events.map((event, index) => (
                                <li key={`${event}-${index}`}>{event}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {pickerVariant === 'modal' && (
                <MediaLibraryManager
                    variant="modal"
                    title="Choose media"
                    selectable
                    initialValue={selected?.id}
                    onSelect={file => {
                        setSelected(file);
                        log(`onSelect: ${describeFile(file)}`);
                        setPickerVariant(null);
                    }}
                    onCancel={() => {
                        log('onCancel');
                        setPickerVariant(null);
                    }}
                    onUpload={file => log(`onUpload: ${describeFile(file)}`)}
                />
            )}
        </section>
    );
}
